"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = 'M19.015 4.985L12.5 19.645v-6.65c0-.823-.677-1.495-1.495-1.495h-6.65l14.66-6.515zM2.995 12.5h8.01c.267 0 .495.226.495.495v8.01c0 1.084.922 1.276 1.365.28L20.05 5.12c.41-.926-.245-1.58-1.17-1.17L2.714 11.136c-.994.442-.816 1.365.28 1.365z';